import {
  useActivePaperTablets,
  useCheckoutAllowed,
  useCountry,
} from 'src/api/queries';

export const useUxSignals = () => {
  const { data: checkoutAllowedData } = useCheckoutAllowed();
  const country = useCountry();
  const activePaperTablets = useActivePaperTablets();

  const hasActiveOffer = checkoutAllowedData?.connectOffer?.allowed;
  const hasDevice = !!activePaperTablets.data?.length;

  const isInUSOrUK =
    country.isSuccess &&
    (country.data.value === 'US' || country.data.value === 'GB');

  const panelId =
    !hasActiveOffer && hasDevice ? 'panel-9c6wr9fth' : 'panel-96c4t8pcsp';

  return {
    shouldLoadScript: isInUSOrUK,
    panelId: panelId,
  };
};
